import React, { FC } from 'react'
import { QueryParamDropdown } from '../components/DropdownMenu/QueryParamDropdown'
import { defaultOption, TIME_FILTER_PARAM, timeFilterOptions } from './util'

export const TimeFilter: FC = () => {
    return (
        <QueryParamDropdown
            defaultOption={defaultOption}
            menuOptions={timeFilterOptions}
            name="Time Filter"
            label="When"
            queryParamName={TIME_FILTER_PARAM}
        />
    )
}
